<div class="flex flex-row gap-3 align-items-end" [formGroup]="settingsForm">
  <div>
    <label class="block font-bold mb-2" for="profile">SAP Profile Name</label>
    <p-select
      inputId="profile"
      [options]="sapProfiles"
      formControlName="sapProfile"
      optionLabel="name"
      optionValue="name"
      showClear="true"
      placeholder="Select a Profile"
    ></p-select>
  </div>
  <div class="flex flex-row gap-3">
    <div class="flex align-items-center">
      <p-radioButton
        name="isRlink"
        [value]="false"
        formControlName="isRlink"
        inputId="false"
      ></p-radioButton>
      <label for="false" class="ml-2 mb-0">base64</label>
    </div>
    <div class="flex align-items-center">
      <p-radioButton
        name="isRlink"
        [value]="true"
        formControlName="isRlink"
        inputId="true"
      ></p-radioButton>
      <label for="true" class="ml-2 mb-0">rlink</label>
    </div>
  </div>
  <div *ngIf="settingsForm.get('isRlink').value">
    <p-checkbox
      formControlName="dummyRlink"
      inputId="rlink"
      binary="true"
    ></p-checkbox>
    <label for="rlink" class="ml-2 mb-0">Generate dummy rlinks</label>
  </div>
</div>
